import { createClient } from '@supabase/supabase-js'
import type { Database } from '../types/database.types'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Faltan variables de entorno de Supabase. Verifica tu archivo .env'
  )
}

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
  },
})

// Helper para verificar conexión
export async function testConnection() {
  try {
    const { error } = await supabase.from('municipios').select('count', { count: 'exact', head: true })
    if (error) throw error
    return { success: true, message: 'Conexión exitosa a Supabase' }
  } catch (error) {
    return { success: false, message: `Error de conexión: ${error}` }
  }
}
